module.exports = __webpack_public_path__ + "static/media/pre5.a76ef185.jpg";